import { signOut, getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { COGNITO_CONFIG } from '../../config/partner';

export const isAuthenticated = async (): Promise<boolean> => {
  try {
    await getCurrentUser();
    return true;
  } catch (error) {
    return false;
  }
};

export const hasReportsAccess = async (): Promise<boolean> => {
  try {
    const session = await fetchAuthSession();
    if (!session.tokens?.idToken) {
      console.error('No ID token available');
      return false;
    }
    const groups = session.tokens.idToken.payload['cognito:groups'] || [];
    
    if (!Array.isArray(groups)) {
      return false;
    }

    // Check for partner admin group
    if (groups.includes(COGNITO_CONFIG.PARTNER_ADMIN_GROUP)) {
      return true;
    }

    // Check for any group that starts with 'reports-'
    return groups.some(group => typeof group === 'string' && group.startsWith('reports-'));
  } catch (error) {
    console.error('Error checking reports access:', error);
    return false;
  }
};

export const signOutUser = async (): Promise<void> => {
  await signOut();
}; 